import { useAction } from 'hooks'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import * as Actions from 'actions'
import { TranslationContext } from 'contexts/TranslationContext'
import { sendWebSocketMessage } from 'middlewares/socketMiddleware'
import { fetchTemporaryToken/* , deleteTemporaryToken */ } from '~/ServerAPI'
import { userProfileSelector } from '~/selectors/user-profile-selector'
import { mobileImport } from '~/AppRoutes'


export const useQRCode = () => {
  const hideQRCodeDialog = useAction(Actions.mainView.showQRCodeDialog, false)
  const sendWebSocket = useAction(sendWebSocketMessage)

  const [ token, setToken ] = useState(null)
  const [ isLoading, setIsLoading ] = useState(true)
  const [ isError, setIsError ] = useState(false)

  const { userId } = useSelector(userProfileSelector)
  const { t } = useContext(TranslationContext)

  useEffect(() => {
    const abortC = new AbortController()
    let isCurrent = true
    let fetchedToken = null

    setIsLoading(true)
    setIsError(false)

    fetchTemporaryToken({ userId }, abortC)
      .then(response => {
        const serverToken = response?.data?.token
        // If unmounting completed before the response arrived
        if (!isCurrent) {
          if (serverToken) {
            // We clean up the token that the server actually managed to create.
            // Token live time 24 hour use this to test after close qrcode
            // deleteTemporaryToken(serverToken)
          }
          return
        }

        if (serverToken) {
          setToken(serverToken)
          fetchedToken = serverToken
          setIsLoading(false)
        } else {
          setIsError(true)
          setIsLoading(false)
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          if (isCurrent) {
            setIsError(true)
            setIsLoading(false)
          }
        }
      })

    return () => {
      isCurrent = false
      abortC.abort()

      if (fetchedToken) {
        /*
        * Comment out the line below if you do not need to delete the token after closing the
        * QR code window or the browser window.
        * Token live time 24 hour use this to test after close qrcode
        */
        // deleteTemporaryToken(fetchedToken)
      }
    }
  }, [ userId, sendWebSocket ])

  return {
    t,
    token,
    qrValue: `${window.location.origin}${mobileImport}?token=${token}`,
    isLoading,
    isError,
    hideQRCodeDialog,
  }
}
